import styled from '@emotion/styled';
import { WHY_US } from 'constant/appConstant';
import { breakPoints } from 'constant/breakPoints';
import { useCallback, useState } from 'react';
import { RectangleBlur } from 'styles/styled';

export default function WhyUs() {
  const [idxCollapse, setIdxCollapse] = useState(-1);

  const onClick = useCallback(
    (idx: number) => () => {
      setIdxCollapse(idx === idxCollapse ? -1 : idx);
    },
    [idxCollapse],
  );

  return (
    <WrapBgr>
      <Bgr>
        <img src="/images/blur.webp" alt="Spirit labs" />
        <RectangleBlur width="398px" rotate={45.07} top="0" right="-254px" />
        <RectangleBlur width="450px" rotate={-135} top="100px" left="-335px" />
      </Bgr>
      <Wrap>
        <div className="title-wrap">Why Us</div>
        <div>
          {WHY_US.map((item, idx) => (
            <Item
              key={idx}
              className={idxCollapse === idx ? 'collapse-in' : ''}
            >
              <div>
                <Title onClick={onClick(idx)}>
                  <div dangerouslySetInnerHTML={{ __html: item.title }} />
                  <CollapseIcon />
                </Title>
                <Des dangerouslySetInnerHTML={{ __html: item.des }} />
              </div>
            </Item>
          ))}
        </div>
      </Wrap>
    </WrapBgr>
  );
}

const WrapBgr = styled.div`
  position: relative;
  z-index: 3;
`;

const Bgr = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 80%;
    height: auto;
  }

  @media screen and (max-width: ${breakPoints.desktopS - 1}px) {
    div:nth-of-type(1) {
      right: -350px;
    }

    div:nth-of-type(2) {
      top: -200px;
      left: -400px;
    }
  }
`;

const Wrap = styled.div`
  padding: 0 16px;
  margin: 0 auto 50px;
  width: 100%;

  .title-wrap {
    margin-bottom: 16px;
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    padding-bottom: 100px;

    .title-wrap {
      text-align: center;
      font-size: 96px;
    }
  }
`;

const Title = styled.div`
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 32px 0;
  cursor: pointer;

  span {
    color: var(--yellow);
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    font-size: 40px;
    line-height: initial;
    display: block;
    text-align: center;
  }
`;

const CollapseIcon = styled.div`
  position: relative;
  flex: 0 0 24px;
  height: 24px;
  margin-right: 0;
  margin-left: auto;

  &::before {
    content: '';
    position: absolute;
    top: calc(50% - 1px);
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #fff;
    transition: all 0.2s ease;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: calc(50% - 1px);
    width: 2px;
    height: 100%;
    background-color: #fff;
    transition: all 0.5s ease;
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    display: none;
  }
`;

const Des = styled.p`
  display: none;
  opacity: 0;

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    font-size: 20px;
    max-width: 722px;
    text-align: center;
    margin: 0 auto;
  }
`;

const Item = styled.div`
  position: relative;
  z-index: 1;
  transition: 0.5s ease;

  & > div {
    max-width: 1140px;
    margin: 0 auto;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    width: 100%;
    max-width: 1140px;
    background: #7d29a6;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    z-index: -1;
    left: -16px;
    width: calc(100% + 32px);
    height: 0;
    transition: 0.5s ease;
    background: linear-gradient(
      302.05deg,
      #a336d9 16.75%,
      rgba(163, 54, 217, 0.6) 73.45%
    );
  }

  @media screen and (max-width: ${breakPoints.desktopS - 1}px) {
    &.collapse-in {
      padding-bottom: 16px;

      &:before {
        height: 100%;
      }

      &:after {
        display: none;
      }

      ${Des} {
        display: block;
        opacity: 1;
      }

      ${Title} {
        padding-bottom: 16px;

        span {
          color: inherit;
        }
      }

      ${CollapseIcon} {
        &::after {
          transform: rotate(90deg);
        }
      }
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    &:hover {
      padding-bottom: 24px;

      &:before {
        height: 100%;
        top: -1px;
      }

      &:after {
        display: none;
      }

      ${Des} {
        display: block;
        opacity: 1;
      }

      ${Title} {
        padding-bottom: 16px;

        span {
          color: inherit;
        }
      }

      ${CollapseIcon} {
        &::after {
          transform: rotate(90deg);
        }
      }
    }
  }
`;
